// src/features/upload/UploadEngineContext.ts

import { createContext } from 'react';
import type { IngestcfgData } from '@/lib/types/Ingest';

export interface UploadEngineValue {
  canIngest: boolean;
  /** Customer the engine uploads into; null while auth/customer resolve or when ingest is unavailable. */
  effectiveCId: number | null;

  // Ingest profiles (useIngestcfgs)
  ingestcfgs: IngestcfgData[];
  selectedIngestcfgId: number | null;
  setSelectedIngestcfgId: (id: number) => void;
  hasMultiple: boolean;
  isRestricted: boolean;

  // Uppy actions (useUppy)
  addFilesWithMeta: (filePairs: Array<{ file: File; uploadItemId: string }>) => void;
  cancelUpload: (uppyFileId: string) => void;
  retryUpload: (uppyFileId: string) => void;
  /** Resume every failed row from its uploaded parts. */
  retryAllFailed: () => void;
  cancelAll: () => void;
  /** Clear terminal rows and release their files from Uppy state. */
  clearCompleted: () => void;
}

export const UploadEngineContext = createContext<UploadEngineValue | null>(null);
